import { MatTableDataSource } from '@angular/material/table';
import { Component, EventEmitter, Input, OnChanges, Output, OnInit } from '@angular/core';
import { ShipmentService } from 'src/app/shared/services/shipment.service';
import { JsonViewComponent } from 'src/app/core/json-view/json-view.component';
import { MatDialog } from '@angular/material/dialog';
import { ValidationsDialogComponent } from 'src/app/core/components/validations-dialog/validations-dialog.component';
import { convertUTCtoUserLocalTimeZone } from '../../../utils/utils';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';

@Component({
  selector: 'app-shipment-history',
  templateUrl: './shipment-history.component.html',
  styleUrls: ['./shipment-history.component.scss'],
})
export class ShipmentHistoryComponent implements OnChanges, OnInit {
  srHistoryData: MatTableDataSource<any>;
  @Output() updateShipmentEvent = new EventEmitter();

  displayedColumns: string[] = ['fileId', 'time', 'shipmentDetails', 'status', 'action'];
  @Input() shipmentData: any;
  historyData: any = [];
  lgData: any = [];
  logRequestoptions = ['GLS label generation', 'Baby Manifest'];
  logFileName: string;
  logType: string;
  logsetailsForm: FormGroup;
  maxDate: any;
  fromdate: any;
  todate: any;
  today = new Date();
  ErrorHistoryMsg = '';
  warningsError: any = [];
  validationErrors: any = [];
  constructor(
    private fb: FormBuilder,
    private shipmentService: ShipmentService,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private errorDialogService: ErrorDialogService
  ) {}

  get showValidationErrors(): boolean {
    return (
      this.validationErrors?.length > 0 &&
      this.shipmentData?.status === 'Validation failed' &&
      !['A', 'B'].includes(this.shipmentData?.productCode)
    );
  }

  get showWarnings(): boolean {
    return this.warningsError?.length > 0 && !['A', 'B'].includes(this.shipmentData?.productCode);
  }

  ngOnInit(): void {
    this.intialiseReportsFormGroup();
  }

  intialiseReportsFormGroup() {
    this.logsetailsForm = this.fb.group({
      logType: ['', Validators.required],
      startDate: [''],
      endDate: [''],
    });
  }

  ngOnChanges() {
    if (this.shipmentData.status == 'Manifest Failed') {
      this.logType = 'Baby Manifest';
    }

    if (
      this.shipmentData.shipperReference != undefined &&
      this.shipmentData.shipmentID != undefined
    ) {
      this.warningsError =
        this.shipmentData.shipment_warning?.length > 0 ? this.shipmentData.shipment_warning : [];
      this.validationErrors =
        this.shipmentData.validationErrors?.length > 0 ? this.shipmentData.validationErrors : [];
      this.getShipmentHistory();
      if (
        this.shipmentData.status == 'Manifested' ||
        this.shipmentData.status == 'Manifest Failed'
      ) {
        this.logRequestoptions = ['GLS label generation', 'Baby Manifest'];
      } else {
        this.logRequestoptions = ['GLS label generation'];
      }
    }
  }

  getShipmentHistory() {
    this.shipmentService
      .getShipmentHistory(this.shipmentData.shipperReference, this.shipmentData.shipmentID)
      .subscribe((res: any) => {
        this.historyData = res?.data;
        if (this.shipmentData.status === 'Manifest Failed') {
          this.downloadLog(false);
        }
        this.srHistoryData = new MatTableDataSource(this.mapDateToDataSource(this.historyData));
      });
  }

  mapDateToDataSource(response) {
    if (response) {
      return response.map(item => ({
        ...item,
        uploaded_datetime: convertUTCtoUserLocalTimeZone(
          item?.uploaded_datetime,
          item?.timezone,
          moment.tz.guess()
        ),
      }));
    }
  }

  showResponseBody(element) {
    const shipRef = this.shipmentData.shipperReference;
    const ReqId = element.req_id;
    const shipmentID = this.shipmentData.shipmentID;
    this.shipmentService.getShipmentHistoryWithReqID(shipRef, ReqId, shipmentID).subscribe(
      res => {
        this.dialog.open(JsonViewComponent, {
          data: res,
        });
      }
      // err => {
      //   console.error('There was an error!', err);
      // }
    );
  }

  sentUpdateDocStatus(req, type) {
    const shipRef = this.shipmentData.shipperReference;
    const ReqId = req.req_id;
    const status = type;
    const shipmentID = this.shipmentData.shipmentID;

    this.shipmentService.updateShipmentHistory(shipRef, ReqId, status, shipmentID).subscribe({
      next: () => {
        this.updateShipmentEvent.emit();
      },
    });
  }

  openDialogErrors(errors) {
    this.dialog.open(ValidationsDialogComponent, {
      data: {
        message: errors,
      },
    });
  }

  getStyle(status) {
    if (status == 'active') {
      return { color: 'green' };
    }
    if (status == 'rejected') {
      return { color: 'red' };
    } else {
      return { color: 'orange' };
    }
  }

  downloadLog(isdownload) {
    if (this.logsetailsForm.value.startDate != '') {
      const d = this.logsetailsForm.value.startDate._d;
      let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate();
      const year = d.getFullYear();
      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }
      this.fromdate = year + month + day;
    }
    if (this.logsetailsForm.value.endDate != '') {
      const d = this.logsetailsForm.value.endDate._d;
      let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate();
      const year = d.getFullYear();
      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }
      this.todate = year + month + day;
    }

    const data = {
      type: this.logType,
      id: this.shipmentData.shipmentID,
      fromdate: this.fromdate,
      todate: this.todate,
    };
    this.shipmentService.getShipmentLogs(data).subscribe((res: any) => {
      this.lgData = res?.body?.data;
      if (this.lgData && this.lgData.length > 0) {
        this.ErrorHistoryMsg = this.lgData[0].res_msg?.detail ?? this.lgData[0].res_msg?.body;
        if (isdownload) {
          this.downloadJson();
        }
      } else {
        if (isdownload) {
          this.errorDialogService.openDialog('alert.noLogsAvailable', false);
        }
      }
    });
  }

  downloadJson() {
    const sJson = JSON.stringify(this.lgData);
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/json;charset=UTF-8,' + encodeURIComponent(sJson));
    //let date = new Date().toISOString().replace(/\s/g, '');
    if (this.fromdate && this.todate) {
      this.logFileName = `${this.logType.replace(' ', '_')}_${this.shipmentData.shipmentID}_${
        this.fromdate
      }_${this.todate}`;
    } else {
      this.logFileName = `${this.logType.replace(' ', '_')}_${this.shipmentData.shipmentID}`;
    }
    element.setAttribute('download', `${this.logFileName}.json`);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  resetMaxDate() {
    if (this.logsetailsForm.get('endDate').value) {
      this.maxDate = new Date();
    }
  }

  setMaxDate() {
    this.maxDate = new Date();
    const tempdate = new Date(this.logsetailsForm.get('startDate').value);
    if (tempdate.getMonth() == this.today.getMonth()) {
      tempdate.setDate(this.maxDate.getDate());
    } else {
      tempdate.setDate(tempdate.getDate() + 30);
      if (tempdate > this.today) {
        tempdate.setDate(this.maxDate.getDate());
      }
    }
    this.maxDate = new Date(tempdate);
  }

  logTypeChanged(logtVal: string) {
    this.logType = logtVal;
  }
}
